/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {get} from './api-calls';
import {INotificationDto} from '../dtos/INotificationDto';

export const getNotifications = (timeZone?: string): Promise<INotificationDto[]> => {
  return get(`/notification?timeZone=${timeZone}`);
};

